/* eslint-disable */
import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import Icon from "@mui/material/Icon";
// @mui/icons-material
import Build from "@mui/icons-material/Build";
import Subject from "@mui/icons-material/Subject";
import FormatPaint from "@mui/icons-material/FormatPaint";
import Code from "@mui/icons-material/Code";
import Dashboard from "@mui/icons-material/Dashboard";
import Timeline from "@mui/icons-material/Timeline";
import Group from "@mui/icons-material/Group";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import Muted from "components/Typography/Muted.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Badge from "components/Badge/Badge.js";

// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";

import projectsStyle from "styles/jss/nextjs-material-kit-pro/pages/sectionsSections/projectsStyle.js";

const useStyles = makeStyles(projectsStyle);

export default function SectionProjects({ ...rest }) {
  const classes = useStyles();
  return (
    <div className="cd-section" {...rest}>
      
      {/* Project 2 START */}
      <div className={classes.projects}>
        <div className={classes.container}>
          
            <GridItem
              xs={12}
              sm={12}
              md={12}
              className={
                classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
              }
            >

              <h2 className={classes.title}>
                Check out some of client success stories!
              </h2>

            </GridItem>

          <GridContainer justifyContent="center" spacing = {4}>
            <GridItem xs={12} sm={6} md={6} >
              <Card >
                <a
                  href="/our-work/bizcap"
                  target="_blank"
                >
                  
                  <CardHeader image plain noShadow>
                    <img
                      src={
                        "/img/sections/bizcap1-small.webp"
                      }
                      alt="..."
                    />

                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/bizcap"
                    target="_blank"
                  >
                    <h4 className={classes.cardTitle}>
                    Client 1: Bizcap
                    </h4>
                  
                  <h6 className={classes.description}>Website Redesign & Marketing Ramp-up </h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    Bizcap is Australia's most open minded lender for business loans. Checkout how we redesigned ther site for SEO.
                  </p>
                  </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6} >
              <Card>
                <a
                  href="/our-work/quallogi"
                  
                >
                  <CardHeader image plain noShadow>
                    <img
                      src="/img/sections/quallogi3-small.webp"
                      alt="..."
                    />

                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/quallogi"
                    
                  >
                    <h4 className={classes.cardTitle}>
                    Client 2: Quallogi
                    </h4>
                  
                  <h6 className={classes.description}>New App Launch & Website</h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    Q by Quallogi is the only electronic work diary (EWD) app for truckies, see hwo we helped them launch.
                    <br/>
                  </p>
                  </a>
                </CardBody>
              </Card>
            </GridItem>
            
          </GridContainer>
        </div>
      </div>
      {/* Project 2 END */}
      
    </div>
  );
}
